export const PanelStyle = `fixed p-4 lg:p-8 bg-white `
export const OverHeaderPanelStyle = `fixed h-full p-4 lg:p-8 top-0 bg-white shadow-lg `
export const ShadowStyle = 'shadow-lg '

export const TransitionTypeStyle = {
    from_left: `left-0 `,
    from_right: `right-0 `,
    from_bottom: `left-0 `,
    fade: ``,
}

export const PanelHeightMinusHeader = `h-full-minus-header `

export const LayoutTypeStyle = {
    panel: `max-h-full max-w-full overflow-y-auto `,
    modal: `top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 max-w-3xl rounded`,
}
